import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { mixpanelSmsCampaign } from '@/utilities/mixpanel/smsCampaigns';
import SmsCampaignsHeader from '@/features/SMSCampaigns/components/list/SMSCampaignsHeader.vue';
import SmsBalance from '@/features/SMSCampaigns/components/SMSBalance.vue';
import SmsCampaignsTable from '@/features/SMSCampaigns/components/list/SMSCampaignsTable.vue';
import Alert from '@/components/_atoms/Alert.vue';
import { whatsappLink } from '@/features/SMSCampaigns/utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsList',
    setup(__props) {
        const store = useStore();
        const balance = computed(() => store.state.smsCampaigns.balance);
        const hasLowBalance = computed(() => balance.value < 1000);
        onMounted(() => {
            mixpanelSmsCampaign.listSmsPageViewed();
        });
        return (_ctx, _cache) => {
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createBlock(_component_base_card_v2, null, {
                default: _withCtx(() => [
                    _createVNode(SmsCampaignsHeader),
                    _createVNode(SmsBalance),
                    (hasLowBalance.value)
                        ? (_openBlock(), _createBlock(Alert, {
                            key: 0,
                            onLinkClick: _cache[0] || (_cache[0] = ($event) => (_unref(mixpanelSmsCampaign).buySms('list'))),
                            type: "error",
                            message: _ctx.$t('sms-campaigns.balance.low-alert', {
                                link: _unref(whatsappLink),
                            })
                        }, null, 8, ["message"]))
                        : _createCommentVNode("", true),
                    _createVNode(SmsCampaignsTable)
                ]),
                _: 1
            }));
        };
    }
});
